<template>
  <TabelaCompraDepartamentos
    :height="height_tabela"
    :grupo="grupo_compra"
    :filial="filial_compra"
    :card="PARAMETROS.card"
    :departamento="departamento_compra"
    :linhas_removidas="linhas_removidas"
    ocultar_titulo
    :callback-nivel1="buscarDepartamento"
    :callback-nivel2="buscarCategoriasSecao"
    :callback-nivel3="buscarProdutosCategoria"
    :qtd_niveis_expancao="3"
    @click:row="selecionarCategoria"
    @itens-data-table="setCategoriasPendentesDeCompra"
    @callback-carregar-dados="salvarReferenciaCallbackAtualizarTabelaProduto"
  >
    <template #item.sugestao_compra_em_preco_de_custo="{item, custo_total_departamento_analise}">
      <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO">
        {{Helpers.formatarValorMonetario(custo_total_departamento_analise)}}
      </template>

      <template v-else>
        {{Helpers.formatarValorMonetario(item.preco_custo * item.sugestao_compra_em_quantidade)}}
      </template>
    </template>

    <template #item.sugestao_compra_em_quantidade="{item, qtd_sugestao_departamento_analise, item_nivel_acima}">
      <AdicionaNoCarrinho
        v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO"
        :linha="item" @produto-adicionado-carrinho="produtoAdicionadoNoCarrinho"
      />

      <div v-else class="text-center pr-11">
        <template v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.TERCEIRO">
          {{Helpers.formatarValor(item_nivel_acima.sugestao_compra_em_quantidade || 0)}}
        </template>
        <template v-else>{{Helpers.formatarValor(qtd_sugestao_departamento_analise)}}</template>
        {{item.unidade_compra}}
      </div>
    </template>
  </TabelaCompraDepartamentos>
</template>

<script>
import TabelaCompraDepartamentos from "../../utils/dataTable/sysDataTableDepartamentos/Index.vue";
import AdicionaNoCarrinho from "./acoesTabela/AdicionaNoCarrinho";

import {buscarDepartamentosCompra} from "../../../api/compraPorDepartamentos/Departamento.js";
import {buscarCategoriasCompraPorSecao} from "../../../api/compraPorDepartamentos/Categoria";
import {buscarProdutosCompraPorCategoria} from "../../../api/compraPorDepartamentos/Produto";

import Responsividade from "../../../helpers/ResponsiveHeight.js";
import {parametros_rota} from "./helpers/ParametrosRota.js";
import {card_selecionado} from "./helpers/CardSelecionado";
import {categoria_selecionada} from "./helpers/CategoriaSelecionado.js";
import {NIVEIS_DE_EXPANCAO} from "../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao";
import {mapGetters} from "vuex";

export default {
  name: "TabelaDepartamento",
  components: {
    TabelaCompraDepartamentos,
    AdicionaNoCarrinho
  },
  mixins: [
    Responsividade,
    parametros_rota,
    card_selecionado,
    categoria_selecionada
  ],
  data: () => ({
    linhas_removidas: [],
    NIVEIS_DE_EXPANCAO
  }),
  computed: {
    ...mapGetters({
      'atualizarPedidoCarrinhoCallback': 'carrinhoDepartamentos/atualizarPedidoCarrinhoCallback'
    }),
    height_tabela() {
      return parseInt(this.alturaDaJanela - 515);
    }
  },
  watch: {
    PARAMETROS() {
      this.linhas_removidas = [];
    }
  },
  methods: {
    salvarReferenciaCallbackAtualizarTabelaProduto({callback}) {
      // essa funcao serve para atualizar a tabela de categorias de qualquer lugar
      this.$store.dispatch("comprasPorDepartamentos/callbackAtualizarTabelaCategorias", callback);
    },
    async buscarDepartamento(filtros) {
      return await buscarDepartamentosCompra(filtros);
    },
    async buscarCategoriasSecao(_, filtros) {
      const parametros = {idsecao: 0, ...filtros};
      return await buscarCategoriasCompraPorSecao(parametros);
    },
    async buscarProdutosCategoria({idcategoria}, filtros) {
      const parametros = {
        idsecao: 0,
        idcategoria,
        ...filtros
      };
      return await buscarProdutosCompraPorCategoria(parametros);
    },
    selecionarCategoria(linha) {
      if (linha.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return;
      if (this.categoria_selecionada && this.categoria_selecionada.idcategoria === linha.idcategoria) return;

      this.categoria_selecionada = linha;
    },
    produtoAdicionadoNoCarrinho(produto) {
      this.linhas_removidas.push(produto);
      this.atualizarPedidoCarrinhoCallback();
    },
    setCategoriasPendentesDeCompra(todos_itens) {
      const categorias = todos_itens.filter(item => item.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO);
      this.$store.dispatch("comprasPorDepartamentos/categorias_pendentes_compra", categorias);
    }
  }
}
</script>

<style scoped>

</style>
